import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';

import clickOutside from './directives/click-outside';

import BootstrapVue from 'bootstrap-vue';
import TreeView from "vue-json-tree-view";

import store from './store';
import router from './router';

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(TreeView);

Vue.config.productionTip = false;

Vue.config.ignoredElements = [
	'hyper-cloud-console'
];

Vue.directive('click-outside', clickOutside);

new Vue({
	render: h => h(App),
	router,
	store
}).$mount('#app');
